import validation from '@/mixins/validation';

export default {
  mixins: [validation],

  computed: {
    emailError() {
      return !this.isValidEmail(this.customer.email) && this.customer.email.length !== 0;
    },

    nameError() {
      return this.customer.name === '';
    },

    firstNameError() {
      return this.customer.firstName === '';
    },

    gsmError() {
      return this.customer.gsm === '';
    },

    ambienceError() {
      return !this.customer.ambience;
    },

    hasCustomerErrors() {
      return this.nameError || this.firstNameError || this.gsmError || this.firstNameError || this.ambienceError || this.emailError;
    },

    streetError() {
      return this.address.street === '';
    },

    postCodeError() {
      return this.address.postCode === '';
    },

    cityError() {
      return this.address.city === '';
    },

    numberError() {
      return this.address.number === '';
    },

    countryError() {
      return this.address.country === '';
    },

    hasAddressError() {
      return this.streetError || this.postCodeError || this.cityError || this.numberError || this.countryError;
    },
  }
};
